import * as r from 'ramda';
import { put, call, select, takeLeading } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import { updateArtsetArtistName } from 'modules/arts/helpers/updateArtsetArtistName';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const UserProfileToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const updateUserProfile = function* (data) {
  const currentUserProfile = yield select(selectors.getUserProfile);
  const { coverPhotoUrl: currentCoverPhotoUrl, profilePhotoUrl: currentProfilePhotoUrl } =
    currentUserProfile;

  const { title, description, tags, socialLinks } = data;
  const tempCoverPhotoUrl = yield select(selectors.getTempCoverPhotoUrl);
  const templProfilePhotoUrl = yield select(selectors.getTempProfilePhotoUrl);

  let profile = {
    Title: title,
    Description: description,
    Labels: tags.join(','),
    CoverPhotoURL: tempCoverPhotoUrl ?? currentCoverPhotoUrl,
    ProfilePhotoURL: templProfilePhotoUrl ?? currentProfilePhotoUrl,
    WebsiteUrl: socialLinks.website,
    FbUrl: socialLinks.facebook,
    instaUrL: socialLinks.instagram,
  };

  const { Data: currentUserProfileData } = yield select(selectors.getUserProfileRaw);
  profile = r.mergeDeepRight(currentUserProfileData, profile);

  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  const { id: userId } = yield select($auth.getCurrentUser);
  const userProfileId = yield select(selectors.getUserProfileId);

  const updatedUserProfile = yield call(
    api.updateUserProfile,
    { userId, userProfileId, profile },
    {
      token,
      publisherId,
    }
  );
  yield put(actions.updateUserProfileSuccess(updatedUserProfile));
};

const updateUserProfileRequest = function* ({ payload }) {
  yield put($ui.setTrue(UI.UserProfile.IsProfileUpdating)());

  try {
    const { userProfileData } = payload;
    yield call(updateUserProfile, userProfileData);

    yield call(updateArtsetArtistName, userProfileData.title);

    yield put($ui.setFalse(UI.UserProfile.DialogVisible)());

    const {
      callbacks: { onSuccess },
    } = payload;
    onSuccess();
  } catch {
    UserProfileToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong. Please try again later or contact support',
    });
  } finally {
    yield put($ui.setFalse(UI.UserProfile.IsProfileUpdating)());
  }
};

export const updateUserProfileSaga = function* () {
  yield takeLeading(actions.updateUserProfile, updateUserProfileRequest);
};
